export default function ({ store, route, redirect, error }) {
  if (!route.query.id) {
    error({
      statusCode: 404,
      message: 'Page not found.'
    })
  }
}